'use client';

import { usePathname } from 'next/navigation';
import { useReveal } from '@/hooks/useReveal';

// Monté une fois dans app/layout.tsx : active les révélations `.rv` de toutes les pages.
export default function Reveal() {
	const pathname = usePathname();
	useReveal([pathname]);
	return null;
}
